import { render, staticRenderFns } from "./AreaChoice.vue?vue&type=template&id=6ae956f6"
import script from "./AreaChoice.vue?vue&type=script&lang=js"
export * from "./AreaChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports